import { render, staticRenderFns } from "./xgPlayer.vue?vue&type=template&id=2be21644&scoped=true"
import script from "./xgPlayer.vue?vue&type=script&lang=js"
export * from "./xgPlayer.vue?vue&type=script&lang=js"
import style1 from "./xgPlayer.vue?vue&type=style&index=1&id=2be21644&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be21644",
  null
  
)

export default component.exports